import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

// 3rd party imports
import { Subscription } from 'rxjs';

// devextrme imports
import { DxPopupComponent } from 'devextreme-angular';

// cc-common imports
import { IconConstants, Utils } from 'cc-common';

// service imports
import { ServerErrorService } from '../../../_services/shared-services/server-error.service';
import { WorkflowSharedService } from '../../_services/workflow-shared.service';
import { PrecisionService } from '../../../_services/shared-services/precision.service';
import { DetailPopupsService } from '../../../cirabooks/shared-cirabooks-module/_services/detail-popups.service';

// model imports
import { WFPaymentHistoryResultDto } from '../../_models/wf-payment-history-result-dto';
import { WorkFlowParametersDto } from '../../_models/workflow-parameters-dto';

// constant imports
import { StringFormatConstants } from '../../../_constants/string-format-constants';

@Component({
    selector: 'app-workflow-payment-history',
    templateUrl: './workflow-payment-history.component.html',
    styleUrls: ['./workflow-payment-history.component.scss']
})
export class WorkflowPaymentHistoryComponent implements OnInit, OnDestroy {
    @ViewChild('workflowPaymentHistoryPopup', { static: false }) workflowPaymentHistoryPopup: DxPopupComponent;

    @Input() workflowId: number;
    @Input() communityId: number;
    @Input() managementCompanyId: number;

    @Output() onClose = new EventEmitter<boolean>();

    paymentHistorySource: WFPaymentHistoryResultDto[] = [];
    hasSourceData = false;
    visible = false;
    loadingVisible = false;
    currencyFormat: string;
    dateFormat: string;

    showPaymentDetail = false;
    paymentDetailUrl: string;

    iconClose = IconConstants.CLOSE;

    forceRefresh = false;
    forceReloadSubscription: Subscription;

    constructor(
        private readonly workflowSharedService: WorkflowSharedService,
        private readonly errorService: ServerErrorService,
        private readonly precisionService: PrecisionService,
        private readonly detailPopupsService: DetailPopupsService
    ) {
        this.currencyFormat = this.precisionService.updatePrecisionPoint(StringFormatConstants.currencyFormat);
        this.dateFormat = StringFormatConstants.dateFormat;
    }

    ngOnInit() {
        this.show();
        this.getPaymentHistory();

        this.forceReloadSubscription = this.detailPopupsService.onForceReload().subscribe(() => {
            this.forceRefresh = true;
            this.getPaymentHistory();
        });
    }

    ngOnDestroy() {
        if (Utils.notNullAndDefined(this.forceReloadSubscription)) {
            this.forceReloadSubscription.unsubscribe();
        }
    }

    show(): void {
        this.visible = true;
    }

    onPaymentHistoryShown(): void {
        this.visible = true;
        this.workflowPaymentHistoryPopup.instance.repaint();
    }

    onPaymentHistoryClose(): void {
        this.visible = false;
        this.onClose.emit(this.forceRefresh);
    }

    onPaymentNumberClick(record: WFPaymentHistoryResultDto): void {
        this.workflowSharedService.updateDetailsParams({
            managementCompanyId: this.managementCompanyId,
            communityId: this.communityId,
            paymentId: record.paymentId
        });
    }

    private getPaymentHistory(): void {
        const baseParams: WorkFlowParametersDto = new WorkFlowParametersDto();
        baseParams.workflowId = this.workflowId;
        baseParams.communityId = this.communityId;

        this.loadingVisible = true;
        this.workflowSharedService.getWorkflowPaymentHistory(baseParams).subscribe(
            (result: WFPaymentHistoryResultDto[]) => {
                result.forEach((row, index) => {
                    row.id = index + 1;
                });

                this.paymentHistorySource = result;

                if (this.paymentHistorySource.length > 0) {
                    this.hasSourceData = true;
                }
                this.loadingVisible = false;
            },
            (error) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }
}
